import { AfterViewInit, Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppUpdateService } from './services/app-update.service';
import { OfflineService } from './services/offline.service';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { ClientDiagnosticsService } from './services/client-diagnostics.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  host: {
    class: 'app-container',
  },
})
export class AppComponent implements OnInit {
  title = 'rep-flow';

  // Initialize the AppUpdateService
  constructor(
    private appUpdateService: AppUpdateService,
    private offlineService: OfflineService,
    private messageService: MessageService,
    private clientDiagnostics: ClientDiagnosticsService,
  ) {}

  ngOnInit(): void {
    this.clientDiagnostics.bootstrap();

    this.offlineService.isOnline$.subscribe((isOnline) => {
      if (isOnline) {
        this.messageService.clear('network');

        this.messageService.add({
          severity: 'success',
          summary: 'Connection restored',
          styleClass: 'network-status',
          closable: false,
          key: 'network',
        });
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Offline. Please check your network',
          sticky: true,
          styleClass: 'network-status',
          closable: false,
          key: 'network',
        });
      }
    });
  }
}
